import { render } from "./TabWorkPermit.vue?vue&type=template&id=72401258&scoped=true"
import script from "./TabWorkPermit.vue?vue&type=script&lang=js"
export * from "./TabWorkPermit.vue?vue&type=script&lang=js"

import "./TabWorkPermit.vue?vue&type=style&index=0&id=72401258&scoped=true&lang=css"
import "./TabWorkPermit.vue?vue&type=style&index=1&id=72401258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72401258"]])

export default __exports__